import * as ko from "knockout";
import * as mapping from "knockout.mapping";

export class Period {
    id: any;
    year: any;
    quarter: any;
    displayName: any;

    constructor(json?: any) {
        this.year = ko.observable<number>();
        this.quarter = ko.observable<number>();

        this.id = ko.pureComputed(() => {
            return this.year() + "-" + this.quarter();
        });
        this.displayName = ko.pureComputed(() => {
            return this.year() + ". " + this.quarter() + ". negyedév";
        });

        if (json) {
            mapping.fromJS(json, {}, this);
        }
    }
}
